import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { TabGroupModel } from '../models/tabGroup.model';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class TabGroupService {
  private configCoreUrl: string;
  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {     
      this.configCoreUrl = data.WebEndPoint2  + 'tabgroup';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }   

    // if (localStorage.getItem('selectedregion') == '1') {
    //   this.configCoreUrl = environment.coreUrl + 'tabgroup';

    // }
    // else {
    //   this.configCoreUrl = environment.coreRowUrl + 'tabgroup';

    // }
  }

  public getAllTabGroups(): Observable<TabGroupModel[]> {
    return this.http.get<TabGroupModel[]>(`${this.configCoreUrl}`);
    // .catch(this.handleError);
  }
  public getAllTabGroupsByEngId(engagementId:number): Observable<TabGroupModel[]> {
    return this.http.get<TabGroupModel[]>(`${this.configCoreUrl}/GetTabGroups/${engagementId}`);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
